import {
    ACTION_ADD_UNSUPPORTED_NFT,
    ACTION_CLEAR_MANAGER_SELECTION,
    ACTION_DISPLAY_SNACKBAR,
    ACTION_PREVIEW,
    ACTION_SELECT_ALL_MANAGER_ITEMS,
    ACTION_SELECT_MANAGER_ITEMS,
    ACTION_SET_MANAGER_CURRENT_MOUSE_POSITION,
    ACTION_SET_MANAGER_PANEL_CLOSED,
    ACTION_SET_MANAGER_PANEL_OPEN,
    ACTION_SET_MANAGER_SEARCH_VALUE,
    ACTION_SET_MANAGER_START_DRAGGING_NFT,
    ACTION_SET_MANAGER_STOP_DRAGGING_NFT,
    ACTION_SET_UNSUPPORTED_NFTS,
    ACTION_TOGGLE_MANAGER_PANEL_MINIFIED,
    ACTION_UPDATE_MANAGER_NFT_FILTERS,
    type NFTManagerActions,
    type NFTManagerState,
} from '../types/nft-manager';

const DEFAULT: NFTManagerState = {
    managerPanelOpen: false,
    managerPanelCollapsed: false,
    draggingItems: [],
    selectedItems: [],
    draggingInitialMouseEvent: null,
    draggingCurrentMousePosition: null,
    managerSearchValue: '',
    managerQueryData: {},
    managerFilters: {},
    displaySnackbar: false,
    selectInPageItems: false,
    selectedAllItems: false,
};

export function nftManager(state: NFTManagerState = DEFAULT, action: NFTManagerActions): NFTManagerState {
    switch (action.type) {
        case ACTION_SET_MANAGER_PANEL_OPEN:
            return { ...state, managerPanelOpen: true, managerPanelCollapsed: false, selectedItems: [] };
        case ACTION_SET_MANAGER_PANEL_CLOSED:
            return { ...state, managerPanelOpen: false, selectedAllItems: false };
        case ACTION_TOGGLE_MANAGER_PANEL_MINIFIED:
            return {
                ...state,
                managerPanelCollapsed: action.collapsed === undefined ? !state.managerPanelCollapsed : action.collapsed,
                selectedItems: [],
                managerFilters: {},
            };

        case ACTION_SET_MANAGER_SEARCH_VALUE:
            return { ...state, managerSearchValue: action.managerSearchValue, unsupportedNfts: [] };

        case ACTION_SET_UNSUPPORTED_NFTS:
            return { ...state, unsupportedNfts: action.unsupportedNfts };

        case ACTION_ADD_UNSUPPORTED_NFT:
            return { ...state, unsupportedNfts: [...(state.unsupportedNfts || []), action.unsupportedNft] };

        case ACTION_SET_MANAGER_START_DRAGGING_NFT: {
            const draggingItems = [...state.selectedItems];
            const itemIndex = draggingItems.findIndex((_itemId) => _itemId === action.item);

            // If item already exists... remove from array
            if (itemIndex !== -1) draggingItems.splice(itemIndex, 1);

            // Add item to end of array (show item in front when dragging)
            draggingItems.push(action.item);

            return { ...state, draggingItems, draggingInitialMouseEvent: action.mouseEvent };
        }
        case ACTION_SET_MANAGER_CURRENT_MOUSE_POSITION:
            return { ...state, draggingCurrentMousePosition: action.currentMousePosition };
        case ACTION_SET_MANAGER_STOP_DRAGGING_NFT:
            return {
                ...state,
                draggingItems: [],
                draggingInitialMouseEvent: null,
                draggingCurrentMousePosition: null,
            };

        case ACTION_CLEAR_MANAGER_SELECTION:
            return { ...state, selectedItems: [], selectedAllItems: false };

        case ACTION_UPDATE_MANAGER_NFT_FILTERS: {
            const managerFilterData = { ...state.managerFilters };

            if (action.clear) {
                return { ...state, managerFilters: {} };
            }

            return {
                ...state,
                managerFilters: {
                    ...managerFilterData,
                    ...action.filter,
                },
            };
        }

        case ACTION_SELECT_ALL_MANAGER_ITEMS: {
            return { ...state, selectedAllItems: !state.selectedAllItems, selectedItems: [], selectInPageItems: false };
        }

        case ACTION_SELECT_MANAGER_ITEMS: {
            if (Array.isArray(action.items)) {
                // If items are an array replace current items with item array
                return {
                    ...state,
                    selectedItems: action.items,
                    selectedAllItems: false,
                    selectInPageItems: action.inPage,
                };
            } else if (state.selectInPageItems !== action.inPage) {
                // If selecting added and not added assets toggle and reset selected
                return {
                    ...state,
                    selectedItems: [action.items],
                    selectedAllItems: false,
                    selectInPageItems: action.inPage,
                };
            } else if (state.selectedItems.includes(action.items)) {
                return {
                    ...state,
                    selectedItems: state.selectedItems.filter((itemId) => itemId !== action.items),
                    selectedAllItems: false,
                };
            }

            // Add item to selected array by default
            return { ...state, selectedItems: [...(state.selectedItems || []), action.items], selectedAllItems: false };
        }

        case ACTION_PREVIEW: {
            return { ...state, selectedItems: [], managerPanelCollapsed: true };
        }

        case ACTION_DISPLAY_SNACKBAR: {
            return { ...state, displaySnackbar: action.direction };
        }

        default:
            return state;
    }
}
